module.exports = __webpack_public_path__ + "img/gaelicfootball-dark.9418cb1e.svg";